 
import api from '../api/instance';
import { LicenseUsageDetails } from '@modules/test-development/models/license-usage.model';

const nameSpace = '/license_usage';


const show = () => {
  return api
    .get(`${nameSpace}`)
    .then((res) => new LicenseUsageDetails().deserialize(res))
    .catch((e) => Promise.reject(e));
};

export const LicenseUsageDetailsService = {
  show,
};

